import { Typography } from '@material-ui/core';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { GenerationToolIcon } from 'src/components/GenerationToolIcon';
import { ASSET_TYPE, getAssetChannelLabel } from 'src/data/asset';
import {
  formatToolDisplayName,
  GENERATION_TOOL,
  getToolClassifiedMixtureSubGenerationTools,
  getToolDefaultAssetType,
  getToolMixtureSubGenerationTools,
  getToolTitle,
  isFreestyleGenerationTool,
  isMixtureTool,
} from 'src/data/generationTool';

import { useStyles } from './useStyles';

export const VariationFormat = ({
  className,
  classes,
  assetType,
  generationTool,
  mixtureSubAssetType,
  showInsightsLabel,
}) => {
  const styles = useStyles({ classes });

  const mixtureTool = () => {
    const mixtureTools = [
      ...getToolMixtureSubGenerationTools(generationTool),
      ...getToolClassifiedMixtureSubGenerationTools(generationTool),
    ];
    return mixtureTools.filter((tool) => getToolDefaultAssetType(tool) === mixtureSubAssetType)[0];
  };

  const resolvedTool =
    isMixtureTool(generationTool) && !getToolTitle(generationTool) ? mixtureTool() : generationTool;
  const isFreestyleTool = isFreestyleGenerationTool(resolvedTool);

  const toolTitle = formatToolDisplayName(resolvedTool, { assetType });

  return (
    <div className={cx(styles.root, className)}>
      {!isFreestyleTool && (
        <GenerationToolIcon
          className={styles.icon}
          tool={resolvedTool}
        />
      )}
      <Typography className={styles.title}>
        {toolTitle || getAssetChannelLabel(assetType)}{' '}
        {showInsightsLabel && (
          <>
            <span>•</span> Insights
          </>
        )}
      </Typography>
    </div>
  );
};

VariationFormat.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({}),
  assetType: PropTypes.oneOf(Object.values(ASSET_TYPE)),
  generationTool: PropTypes.oneOf(Object.values(GENERATION_TOOL)),
  mixtureSubAssetType: PropTypes.string,
  showInsightsLabel: PropTypes.bool,
};

VariationFormat.defaultProps = {
  className: null,
  assetType: null,
  generationTool: null,
  classes: null,
  mixtureSubAssetType: null,
  showInsightsLabel: null,
};
